module.exports = __webpack_public_path__ + "img/complete.f96ea964.svg";